<div class="wrapper">
	<input
		type="text"
		placeholder="N/A"
		[value]="fieldValue"
		(keyup)="onKeyUp($event)"/>
</div>
